import { Record } from 'immutable';
const FilterOperatorDescription = Record({
  filterFamily: undefined,
  operator: undefined
});
FilterOperatorDescription.isValid = record => record instanceof FilterOperatorDescription;
export default FilterOperatorDescription;